import React, {FunctionComponent} from "react";
import {SeasonRating} from "/src/domain/challenges/ChallengeUserRatingData";
import makeStyles from "@mui/styles/makeStyles";
import {theme} from "/src/assets/theme";
import {Typography} from "@mui/material";
import {ChallengeRatingView} from "/src/ui/challengeUserRating/ChallengeRatingView";

export type SeasonRatingViewProps = {
    rating: SeasonRating
};

export const SeasonRatingView: FunctionComponent<SeasonRatingViewProps> = ({rating}) => {
    const classes = useStyles();

    return (
        <>
            <Typography className={classes.header} variant="subtitle1">{rating.season.name}</Typography>
            {
                rating.ratings.map(r => (<ChallengeRatingView rating={r} key={r.id}/>))
            }
        </>
    )
}

const useStyles = makeStyles(muiTheme => ({
    header: {
        padding: "0.5rem 1rem",
        background: theme.lightSecondaryColor,
        color: theme.secondaryColor,
    }
}));